import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IFieldState {
  submitCount: number;
}

const initialState = {
  submitCount: 0,
};

const submitCounter = createSlice({
  name: "submitCounter",
  initialState,
  reducers: {
    setSubmitCount: (state, action: PayloadAction<number>) => {
      state.submitCount = action.payload;
    },
  },
});

export const { setSubmitCount } = submitCounter.actions;

export const selectSubmitCounter = (state: { counter: IFieldState }) =>
  state.counter.submitCount;

export const counter = submitCounter.reducer;
